/**
 * MODULE: domain/sales-profile/frontend/hooks/useSalesHub.tsx
 * PURPOSE: Sales Hub context provider – global state for content type and search
 * DEPENDENCIES: React (createContext, useContext, useState)
 * AGENT SAFETY: SAFE
 * FILE SIZE: ~44 / 100 lines
 * Recent: 2026-02-05 Sales Hub refactor
 */

import React, { createContext, useContext, useState, ReactNode } from 'react';

interface SalesHubContextValue {
  selectedContentType: string;
  setSelectedContentType: (type: string) => void;
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}

const SalesHubContext = createContext<SalesHubContextValue | undefined>(undefined);

export const SalesHubProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [selectedContentType, setSelectedContentType] = useState<string>('all');
  const [searchQuery, setSearchQuery] = useState<string>('');

  return (
    <SalesHubContext.Provider
      value={{
        selectedContentType,
        setSelectedContentType,
        searchQuery,
        setSearchQuery,
      }}
    >
      {children}
    </SalesHubContext.Provider>
  );
};

export const useSalesHub = (): SalesHubContextValue => {
  const context = useContext(SalesHubContext);
  if (!context) {
    throw new Error('useSalesHub must be used within SalesHubProvider');
  }
  return context;
};
